import { render } from "./CoverageNew.vue?vue&type=template&id=1fcf08ef"
import script from "./CoverageNew.vue?vue&type=script&lang=js"
export * from "./CoverageNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__